import { type VariantProps, cva } from 'class-variance-authority';
import * as React from 'react';

import { Typography } from '../typography/typography';
import { Attachment } from '../icons';
import { cn } from '../../utils';

const filePreviewVariants = cva(
  'w-full grid grid-cols-[auto_1fr] rounded-lg border border-border-weak bg-surface-background',
  {
    variants: {
      size: {
        sm: 'h-10',
        md: 'h-14',
        lg: 'h-18',
      },
    },
    defaultVariants: {
      size: 'md',
    },
  },
);

export interface FilePreviewProps extends VariantProps<typeof filePreviewVariants> {
  file: File;
  actions?: React.ReactNode;
  className?: string;
}

export const FilePreview: React.FC<FilePreviewProps> = ({ file, actions, className, size }) => {
  return (
    <div className={cn(filePreviewVariants({ size }), className)}>
      <div
        className={cn(
          'flex justify-center items-center bg-surface-weak rounded-l-lg aspect-square h-full',
        )}
      >
        <Attachment
          className={cn(
            'text-surface',
            cn({
              'size-4': size === 'sm',
              'size-5': size === 'md',
              'size-6': size === 'lg',
            }),
          )}
        />
      </div>

      <div className="flex px-4 gap-2 items-center justify-between w-full overflow-hidden">
        <Typography variant="paragraphBasicBook" className="truncate">
          {file.name}
        </Typography>

        {actions}
      </div>
    </div>
  );
};
